import { Injectable } from '@angular/core';
import swal, {  SweetAlertResult } from 'sweetalert2';
import { TypeAlert } from '../shared/constants/enums.interface';

@Injectable({
    providedIn: 'root'
  })

export class Alerts {
    Notificacion(tipoAlert: TypeAlert, message: string, title :string): Promise<SweetAlertResult<any>> {
      const baseConfig = {
        imageWidth: 85,
        imageHeight: 85,
        customClass: {
          container: 'low-z-index-swal' // Aplicar la clase de bajo z-index
      }
      };
    
      let swalConfig: any;
      switch (tipoAlert) {
        case TypeAlert.Confirm:
          swalConfig = swal.mixin({
            ...baseConfig,
            title: 'Confirmación!',
            html: message,
            showDenyButton: true,
            showConfirmButton: true,
            showCancelButton: false,
            imageUrl: 'assets/img/logo_atencion.png',
            confirmButtonText: 'SI',
            denyButtonText: 'NO',
          });
          break;
          case TypeAlert.ConfirmStep:
            swalConfig = swal.mixin({
              ...baseConfig,
              title: title,
              html: message,
              showDenyButton: true,
              showConfirmButton: true,
              showCancelButton: false,
              imageUrl: 'assets/img/logo_atencion.png',
              confirmButtonText: 'Continuar',
              denyButtonText: 'Cancelar',
            });
            break;
        case TypeAlert.Info:
          swalConfig = swal.mixin({
            ...baseConfig,
            title: title ?? "INFORMACIÓN",
            html: message,
            imageUrl: 'assets/img/logo_atencion.png',
            confirmButtonText: 'ACEPTAR',
          });
          break;
        case TypeAlert.Error:
          swalConfig = swal.mixin({
            ...baseConfig,
            icon: 'error',
            title: 'Error',
            html: message,
            confirmButtonText: 'ACEPTAR',
          });
          break;
        case TypeAlert.Success:
          swalConfig = swal.mixin({
            ...baseConfig,
            title: title,
            html: message,
            imageUrl: 'assets/icons/success.svg',
            confirmButtonText: 'ACEPTAR',
          });
          break;
        case TypeAlert.Validation:
          swalConfig = swal.mixin({
            ...baseConfig,
            title: title ?? "VALIDACIÓN",
            html: message,
            imageUrl: 'assets/img/logo_atencion.png',
            confirmButtonText: 'ACEPTAR',
          });
          break;
          case TypeAlert.Aceptar:
            swalConfig = swal.mixin({
              ...baseConfig,
              title: 'Confirmación!',
              html: message,
              showConfirmButton: true,
              showCancelButton: false,
              imageUrl: 'assets/img/logo_atencion.png',
              confirmButtonText: 'Aceptar',
            });
            break;  
      }
      return swalConfig.fire();
    }
}